import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Button,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
} from '@material-ui/core';

import { Etapas } from './Etapas';

import { instanceAxios } from 'src/InstanceAxios';
import TableData from '../ServicosContratados/components/TableData';

const columns = [
  { id: 'servico', title: 'Serviço', field: 'servico' },
  { id: 'date', title: 'Data Solicitação', field: 'date' },
  { id: 'status', title: 'Status', field: 'status' },
  { id: 'responsavel', title: 'Responsável', field: 'responsavel' },
  { id: 'etapa', title: 'Etapa', field: 'etapa' },
  { id: 'acoes', title: 'Ações', field: 'acoes' },
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },

  paper: {
    position: 'absolute',
    backgroundColor: '#fff',
    border: '2px solid #000',
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    overflow: 'auto',
  },
});

const StatusServicos = () => {
  const [services, setServices] = useState([]);
  const [serviceId, setServiceId] = useState(null);
  const [status, setStatus] = useState('');
  const [openModal, setOpenModal] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    getServices();
  }, []);

  function getStatus(status) {
    const objStatus = {
      1: 'Em Aberto',
      2: 'Andamento',
      3: 'Feito',
      4: 'Cancelado',
    };

    status.map((item) => {
      return setStatus(objStatus[item.status]);
    });
  }

  async function getServices() {
    const userId = localStorage.getItem('idadmin');
    const token = localStorage.getItem('toobiauth');

    try {
      const response = await instanceAxios(token).get(
        `/servicosContratados/${userId}`
      );
      console.log('🚀 ~ response > ', response.data);

      setServices(response.data);
      setServiceId(response.data[0].id);
      getStatus(response.data);
    } catch (error) {
      console.log('error > ', error);
    }
  }

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.id} style={{ fontWeight: 'bold' }}>
                {column.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {services.map((service) => (
            <TableRow key={service.id}>
              <TableCell>{service.Servico.nome}</TableCell>
              <TableCell>
                {moment(service.created_at).format('DD/MM/YYYY')}
              </TableCell>

              <TableCell>{status}</TableCell>
              <TableCell>{service.Admin?.nome}</TableCell>
              <TableCell>
                <TableData etapas={service} />
              </TableCell>

              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ fontWeight: 'bold' }}
                  onClick={() => setOpenModal((openModal) => !openModal)}
                >
                  Detalhes
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={openModal}
        onClose={() => setOpenModal((openModal) => !openModal)}
      >
        <div className={classes.paper}>
          <Etapas serviceId={serviceId} />
        </div>
      </Modal>
    </TableContainer>
  );
};

export default StatusServicos;
